export default __webpack_public_path__ + "static/media/item4.9659136a.jpg";